import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { useTabs } from './context'
import useCallbackRef from '../hooks/useCallbackRef'
import { useConfig } from '../ConfigProvider'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

const TabNav = forwardRef((props, ref) => {
  const {
    value: valueProp,
    disabled,
    className,
    icon,
    children,
    useHash = true,
    ...rest
  } = props

  const { value, onValueChange, variant } = useTabs()
  const navigate = useNavigate()
  const isSelected = valueProp === value

  const { themeColor, primaryColorLevel } = useConfig()

  const onTabNavClick = useCallbackRef(() => {
    if (useHash) {
      if (!isSelected && !disabled) {
        navigate(`#${valueProp}`)
      }
    } else if (!isSelected && !disabled) {
      onValueChange(valueProp)
    }
  })

  const color = `${themeColor}-${primaryColorLevel}`

  const tabNavClass = classNames(
    'tab-nav',
    'min-w-fit',
    `tab-nav-${variant}`,
    isSelected && `tab-nav-active text-${color}`,
    isSelected && variant === 'underline' && `border-${color}`,
    isSelected && variant === 'pill' && `bg-${themeColor}-50`,
    disabled && 'tab-nav-disabled',
    !disabled && !isSelected && `hover:text-${color}`,
    className
  )

  return (
    <div
      className={tabNavClass}
      role="tab"
      aria-selected={isSelected}
      ref={ref}
      onClick={onTabNavClick}
      {...rest}
    >
      {icon && <div className="tab-nav-icon">{icon}</div>}
      {children}
    </div>
  )
})

TabNav.displayName = 'TabNav'

TabNav.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default TabNav
